(function () {
  const parameterName = 'rd_code';
  const storageKey = 'moshimo_rd_code';
  const expiryKey = 'moshimo_rd_code_expires_at';

  const attributionDays = 30;
  const maxAgeSeconds = 60 * 60 * 24 * attributionDays;

  try {
    const now = Date.now();
    const expiresAt = Number(
      window.localStorage.getItem(expiryKey)
    );

    if (expiresAt && now >= expiresAt) {
      window.localStorage.removeItem(storageKey);
      window.localStorage.removeItem(expiryKey);

      document.cookie = [
        `${storageKey}=`,
        'path=/',
        'max-age=0',
        'SameSite=Lax',
        'Secure'
      ].join('; ');
    }

    const url = new URL(window.location.href);
    const rdCode = url.searchParams.get(parameterName);

    if (!rdCode) {
      return;
    }

    const normalizedRdCode = rdCode.trim();

    if (!normalizedRdCode) {
      return;
    }

    const newExpiresAt =
      now + maxAgeSeconds * 1000;

    window.localStorage.setItem(
      storageKey,
      normalizedRdCode
    );

    window.localStorage.setItem(
      expiryKey,
      String(newExpiresAt)
    );

    document.cookie = [
      `${storageKey}=${encodeURIComponent(normalizedRdCode)}`,
      'path=/',
      `max-age=${maxAgeSeconds}`,
      'SameSite=Lax',
      'Secure'
    ].join('; ');
  } catch (error) {
    console.error(
      'Failed to manage Moshimo session code.',
      error
    );
  }
})();